import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "horizontal-lines-plus",
  "use": "horizontal-lines-plus-usage",
  "viewBox": "0 0 13 13",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 13 13\" id=\"horizontal-lines-plus\">\n  <path fill-rule=\"evenodd\" d=\"M434,436h13v2H434v-2Zm0,4h13v2H434v-2Zm4,6h5v1h-5v-1Zm2-2h1v5h-1v-5Z\" transform=\"translate(-434 -436)\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icons/horizontal-lines-plus.svg
// module id = null
// module chunks = 